import { MvcLocation } from "@repo/models";
import { TLPComponents } from "@repo/ui";
import { LocationPortal as App } from "location-portal";
import { MemoryRouter } from "react-router-dom";

import { getInitialUrl } from "../helpers/locationPortal";

interface LocationPortalProps {
	locationId: number | null;
	selectedTab?: string;
	location?: MvcLocation;
}

export function LocationPortal({ locationId, selectedTab, location }: LocationPortalProps) {
	return (
		<MemoryRouter initialEntries={[getInitialUrl(locationId, selectedTab)]} initialIndex={0}>
			<App locationId={locationId ?? undefined} location={location} />
			<TLPComponents showToastContainer={false} />
		</MemoryRouter>
	);
}
